import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { saveUserCourseeEaluateVO } from "@/api/aijiaoaiCourse";
interface UserRateIF {
    courseId: number; //课程ID;
    contentGrade: number; //课程内容评分
    platformGrade: number; //平台评分
    teachingGrade: number; //教学服务评分
    advice?: string; //其他建议
}
@Component({
    components: {
        name: UserRate
    }
})
export default class UserRate extends Vue {
    @Prop()
    private showCourseRate: any;

    private FeedBackVO: UserRateIF = {
        courseId: null,
        contentGrade: 0,
        platformGrade: 0,
        teachingGrade: 0,
        advice: ""
    };
    mounted() {
        this.FeedBackVO.courseId = parseInt(this.$route.params.courseId);
    }

    handleSubmitRateClick() {
        if (
            this.FeedBackVO.contentGrade !== 0 &&
            this.FeedBackVO.platformGrade !== 0 &&
            this.FeedBackVO.teachingGrade !== 0
        ) {
            saveUserCourseeEaluateVO(this.FeedBackVO).then(res => {
                //@ts-ignore
                if (res.code === 200) {
                    this.$message.success("提交成功，感谢您的反馈");
                    this.handleRateClose();
                }
            });
        } else {
            this.$message.warning("评分完成后才能提交");
        }
    }
    handleRateClose() {
        this.$set(this.showCourseRate, "isShowRate", false);
    }
}
//@ts-ignore
export { default as UserRate } from "./index.vue";
